import React from 'react';
import { Box } from '@mui/material';
import {
  History,
  Sync,
  ViewKanbanOutlined,
  PeopleOutline,
} from '@mui/icons-material';
import { LandingSpotlight } from './LandingEffects';
import { Mono, useModeTokens } from '@/common/components/ui';
import { ANCHOR, FEATURES } from './content';

const ICONS = [History, Sync, ViewKanbanOutlined, PeopleOutline];

/** The product's core workflows, stated once each. */
export const LandingFeatures: React.FC = () => {
  const t = useModeTokens();

  return (
    <Box
      id="lp-product"
      sx={{
        ...ANCHOR,
        padding: {
          xs: '52px 20px 44px',
          sm: '60px 28px 50px',
          md: '66px 40px 56px',
        },
        display: 'grid',
        gridTemplateColumns: {
          xs: 'minmax(0, 1fr)',
          sm: 'repeat(2, minmax(0, 1fr))',
          lg: 'repeat(4, minmax(0, 1fr))',
        },
        gap: '20px',
      }}
    >
      {FEATURES.map((feature, index) => {
        const Icon = ICONS[index];
        return (
          <LandingSpotlight key={feature.rubric}>
            <Box
              sx={{
                padding: '24px',
              }}
            >
              <Icon
                sx={{ color: t.colors[feature.color], fontSize: 28, mb: 3 }}
              />
              <Mono
                size={10}
                weight={600}
                letterSpacing="0.14em"
                color={t.colors[feature.color]}
                sx={{ display: 'block', marginBottom: '14px' }}
              >
                {feature.rubric}
              </Mono>
              <Box
                component="h3"
                sx={{
                  margin: '0 0 8px',
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  fontWeight: 700,
                  fontSize: '22px',
                  letterSpacing: '-0.02em',
                }}
              >
                {feature.title}
              </Box>
              <Box
                component="p"
                sx={{
                  margin: 0,
                  fontSize: '13.5px',
                  lineHeight: 1.6,
                  color: t.text.secondary,
                }}
              >
                {feature.body}
              </Box>
            </Box>
          </LandingSpotlight>
        );
      })}
    </Box>
  );
};

export default LandingFeatures;
